/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/************************* Preact Files ************************/
import { Component } from "preact";
import { connect } from "preact-redux";

import ArticleItem from "../../components/articleItem";
import Sankey from "../../components/sankey";

/********************** Redux Action Files *********************/
import { updateSearchText } from "../../shared/actions/searchActions";
import {
  clearSearchCountryField,
  searchResult,
  searchOperatingUnitsListData,
} from "../../components/nestedDropList/actions";
import { onChangeRoute } from "../../shared/actions/routerActions";

/************************ Style files  *************************/
import style from "./style";
class Home extends Component {
  getSankeyYear = (year) => {
    this.setState({ sankeyYear: year });
  };

  getBugetType = (type) => {
    const bugetType = type ? "budget" : "expense";
    this.setState({ bugetType });
  };

  constructor(props) {
    super(props);
    this.state = {
      sankeyYear: this.props.yearList.list[0],
      bugetType: "budget",
    };
  }

  componentWillMount() {
    this.props.clearSearchCountryField();
    this.props.searchOperatingUnitsListData();
  }

  componentDidMount() {
    this.props.onChangeRoute("UNRWA Transparency Portal");
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.mapData.yearTimeline.mapCurrentYear !==
      this.props.mapData.yearTimeline.mapCurrentYear
    ) {
      this.props.searchOperatingUnitsListData();
    }
  }

  componentWillUnmount() {
    this.props.clearSearchCountryField();
  }

  render(props, { sankeyYear, bugetType }) {
    return (
      <div>
        <div class={style.financial_flow}>
          <ArticleItem
            title={"Financial Flow"}
            description={
              "Find out where UNRWA’s resources come from, where they go and how they are changing people’s lives."
            }
          />
          <Sankey
            getSankeyYear={this.getSankeyYear}
            getBugetType={this.getBugetType}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  searchAllResult: state.searchAllResult,
  mapData: state.mapData,
  yearList: state.yearList,
});

const mapDispatchToProps = (dispatch) => ({
  updateSearchText: (data) => dispatch(updateSearchText(data)),
  searchOperatingUnitsListData: (searchParam, key) =>
    dispatch(searchOperatingUnitsListData(searchParam, key)),
  clearSearchCountryField: () => dispatch(clearSearchCountryField()),
  searchResult: (searchParam, key) => dispatch(searchResult(searchParam, key)),
  onChangeRoute: (title) => dispatch(onChangeRoute(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./routes/tmp_home_financial_component/index.js